// extracted by mini-css-extract-plugin
export default {"root":"side-bar_root__YwCdM","logo":"side-bar_logo__eMdLU","googleMaps":"side-bar_googleMaps__rbUxd"};